import { gql } from "@apollo/client";

const BOOKING = `
  orderId
  bookingId
  day
  employeeId
  employeeName
  price
  amountPaid
  outsideRazorpay
  paymentType
  verificationStatus
`;

export const GET_MONEY_WATCH = gql`
  query GetMoneyWatch($startDate: String, $endDate: String) {
    getMoneyWatch(startDate: $startDate, endDate: $endDate) {
      status
      message
      data {
        range {
          startDate
          endDate
        }
        thresholds {
          cashDays
          verifyDays
        }
        cash {
          amount
          overdueAmount
          overdueBookings
          employees {
            employeeId
            employeeName
            bookings
            amount
            overdueAmount
            overdueBookings
            oldestDay
          }
        }
        onlineOutsideRazorpay {
          amount
          bookings
          unverified
          employees {
            employeeId
            employeeName
            bookings
            amount
          }
          items { ${BOOKING} }
        }
        unverified {
          bookings
          amount
          items { ${BOOKING} }
        }
        unlinkedRazorpay {
          count
          amount
          items {
            id
            razorpayPaymentId
            amount
            method
            vpa
            contact
            paidAt
            suggestedKind
          }
        }
        codSettledOnline
        office {
          walletCredited
          manualPayments
          people {
            actorId
            actorName
            walletCredited
            walletCredits
            manualPayments
            manualPaymentCount
            ledgerEdits
          }
        }
      }
    }
  }
`;
